if (!customElements.get('lazy-autoplay-video')) {
  customElements.define('lazy-autoplay-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.visibilityObserver) return;

      if (!('IntersectionObserver' in window)) {
        this.loadAndPlay();
        return;
      }

      this.visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadAndPlay();
          } else {
            this.video.pause();
          }
        });
      }, { rootMargin: '200px 0px', threshold: 0.01 });
      this.visibilityObserver.observe(this.video);
    }

    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
    }

    loadAndPlay() {
      if (this.video.dataset.loaded !== 'true') {
        this.video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        this.video.dataset.loaded = 'true';
        this.video.load();
      }
      this.video.play().catch(() => {});
    }
  });
}
